import token from '@uipath/apollo-core';
export const MuiIconButton = (palette) => ({
    root: {
        color: palette.semantic.colorIconDefault,
        padding: token.Padding.PadL,
    },
});
